module.exports = __webpack_public_path__ + "static/media/btn_benefit_cate_on.52f33d76.png";